import React, { useCallback, useContext } from 'react';
import ImagemModalRenegociacao from '../../assets/novosicones/Renegociacao/ModalRenegociacao/imagem-modal-renegociacao.png';
import ModalBanner from '../../Components/ModalBanner';
import {
  ModalWrapper,
  HeaderWrapper,
  BodyWrapper,
  TitleWrapper,
  ParagraphWrapper,
  InfoWrapper,
} from './styled';
import CloseButton from '../Reutilizaveis/CloseButton';
import { ButtonPrimary } from '../StyledComponent';
import { useHistory } from 'react-router-dom';
import { ContextGetData } from '../../services/getData';

const ModalInformativoRenegociacao = ({
  setShowModalInformativoRenegociacao,
  tema,
}) => {
  const history = useHistory();
  const { contratosRenegociacao } = useContext(ContextGetData);

  const closePaymentModal = useCallback(() => {
    setShowModalInformativoRenegociacao(false);
  }, []);

  const onClickRenegociar = useCallback(() => {
    history.push('/financeiro', {
      idVenda: contratosRenegociacao[0]?.IdVenda,
      redirectRenegociar: true,
    });
    setShowModalInformativoRenegociacao(false);
  }, []);

  return (
    <ModalBanner showBanner zIndex='20000'>
      <ModalWrapper tema={tema}>
        <HeaderWrapper>
          <CloseButton
            tamanho='18px'
            tamanhoIcone='18px'
            color='#fff'
            borderColor='transparent'
            marginRight={12}
            marginTop={12}
            onClick={closePaymentModal}
            id={'btnCloseModal'}
          />
        </HeaderWrapper>
        <BodyWrapper tema={tema}>
          <img src={ImagemModalRenegociacao} />
          <InfoWrapper>
            <TitleWrapper>Renegocie seu débito</TitleWrapper>
            <ParagraphWrapper>
              Você está apto para fazer a renegociação de suas parcelas e ficar
              em dia.
            </ParagraphWrapper>
            <ButtonPrimary
              white
              fullWidth
              tema={tema}
              onClick={onClickRenegociar}
              id={'btnRenegociar'}
            >
              Renegociar
            </ButtonPrimary>
          </InfoWrapper>
        </BodyWrapper>
      </ModalWrapper>
    </ModalBanner>
  );
};

export default ModalInformativoRenegociacao;
